import { VaiVemAPI } from "@/api/vai-vem.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import {map} from "rxjs/operators";
import {BASE_PATH_APP} from "@/commons/config";

const api = new VaiVemAPI();

const findByStudant = (cpf:string, dataNascimento: string):AxiosObservable<any> =>{
    return api.findByStudant(cpf,dataNascimento)
}

const confirmReceipt = (cpfAluno: string, idUsuario_entrega: string, nomeUsuario_entrega: string):AxiosObservable<any> =>{
  return api.confirmReceipt(cpfAluno, idUsuario_entrega, nomeUsuario_entrega);
}

const AUTH = `${BASE_PATH_APP}-vaivem-auth`

const buildAuthDetran = ({access_token, functionalities }) => {
  localStorage.setItem(AUTH+'-detran', JSON.stringify({ token: access_token, functionalities }));
}
const setSessionDetran = (response: any)=> {
  buildAuthDetran(response);
}

const loginDetran = ()=>{
  return api.loginDetran().pipe(map(response => setSessionDetran(response)));
}

const findByDesempregado = (cpf: [], dataNascimento: string):AxiosObservable<any> =>{
  return api.findByDesempregado(cpf, dataNascimento);
}

const confirmaEntregaDesempregado = (cpf: string, data_entrega: string): AxiosObservable<any> =>{
  return api.confirmaEntregaDesempregado(cpf,data_entrega);
}

export default {
    findByStudant,
    confirmReceipt,
    loginDetran,
    findByDesempregado,
    confirmaEntregaDesempregado
}
